module.exports = __webpack_public_path__ + "static/img/1.1b508b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R507/1.jpg
// module id = +/C8
// module chunks = 1